module.exports = __webpack_public_path__ + "img/microphone-ic.f54fb00b.svg";